import { useEffect, useRef, useState } from "react";
import dragon from "../../assets/ui/mascot/dragon.png";
import "./recognition-sequence.css";

export function RecognitionSequence({ items, title = "Разбираю полученные данные", completeText, headingId, onComplete }: { items: string[]; title?: string; completeText: string; headingId?: string; onComplete: () => void }) {
  const [visible, setVisible] = useState(0);
  const [complete, setComplete] = useState(false);
  const cards = useRef<HTMLDivElement>(null);
  const scrollFrame = useRef<number | null>(null);
  const completeRef = useRef(onComplete);
  completeRef.current = onComplete;

  useEffect(() => {
    setVisible(0); setComplete(false);
    if (!items.length) return;
    const timers = items.map((_, index) => window.setTimeout(() => setVisible(index + 1), 220 + index * 390));
    const done = window.setTimeout(() => setComplete(true), 360 + items.length * 390);
    const leave = window.setTimeout(() => completeRef.current(), 1_350 + items.length * 390);
    return () => { timers.forEach(window.clearTimeout); window.clearTimeout(done); window.clearTimeout(leave); };
  }, [items]);

  useEffect(() => {
    const container = cards.current;
    if (!container) return;
    if (scrollFrame.current !== null) { window.cancelAnimationFrame(scrollFrame.current); scrollFrame.current = null; }
    const start = container.scrollTop;
    const target = Math.max(0, container.scrollHeight - container.clientHeight);
    if (target <= start + 1) return;
    const startedAt = performance.now();
    const duration = 320;
    const move = (now: number) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      container.scrollTop = start + (target - start) * eased;
      if (progress < 1) scrollFrame.current = window.requestAnimationFrame(move);
      else scrollFrame.current = null;
    };
    scrollFrame.current = window.requestAnimationFrame(move);
    return () => { if (scrollFrame.current !== null) window.cancelAnimationFrame(scrollFrame.current); };
  }, [visible]);
  const progress = items.length ? Math.round(visible / items.length * 100) : 0;
  return <section className={`recognition-sequence${complete ? " is-complete" : ""}`} aria-live="polite">
    <img className="recognition-dragon" src={dragon} alt="" />
    <h2 id={headingId}>{complete ? completeText : title}</h2>
    <div className={`recognition-progress${items.length ? " has-result" : " is-waiting"}`} aria-label={items.length ? `Обработано ${visible} из ${items.length}` : "Идёт обработка"}><span style={items.length ? { width: `${progress}%` } : undefined} /></div>
    <div className="recognition-cards" ref={cards}>
      {items.slice(0, visible).map((item, index) => <div className="recognition-card" key={`${item}-${index}`}><span>✓</span><strong>{item}</strong></div>)}
      {!items.length && <p className="recognition-empty">Сейчас здесь появятся распознанные позиции</p>}
    </div>
    <div className="recognition-complete-slot">{complete && <div className="recognition-complete-mark" aria-hidden="true">✓</div>}</div>
  </section>;
}
